import HomePage from "@/pages/home/page"
import ChiSiamoPage from "@/pages/chisiamo/page"
import TrattamentiPage from "@/pages/trattamenti/page"
import GalleryPage from "@/pages/gallery/page"
import ConsulenzaPage from "@/pages/consulenza/page"
import AdminPage from "@/pages/admin/page"
import LoginPage from "@/pages/login/page"
import TrattamentoDettaglioPage from "@/pages/trattamenti/dettaglio/page"

const routes = [
  { path: "/", element: <HomePage /> },
  { path: "/chi-siamo", element: <ChiSiamoPage /> },
  { path: "/trattamenti", element: <TrattamentiPage /> },
  { path: "/gallery", element: <GalleryPage /> },
  { path: "/consulenza", element: <ConsulenzaPage /> },
  { path: "/admin", element: <AdminPage /> },
  { path: "/alkimya-admin-937", element: <LoginPage /> },
  { path: "/trattamenti/:id", element: <TrattamentoDettaglioPage /> }
]


export default routes